import { GET_USER_INFO } from './jigsaw-methods';
import { isPending } from '../redux-util/async-helpers';

export function getUserProfile(state) {
  const base = state.jigsaw[GET_USER_INFO].data;
  return base ? base.user : {};
}

export function devicesHaveBeenFetched(state) {
  return !!state.jigsaw.devices.successQuery;
}

export function getActiveUserDevices(state) {
  const base = state.jigsaw.devices.data;
  return base && base.devices ? base.devices.filter(d => d.active) : [];
}

export function devicesLoading(state) {
  return state.jigsaw.devices.isFetching;
}

export function hasDevicesError(state) {
  return state.jigsaw.devices.hasError;
}

export function isLoggedInToJigsaw(state) {
  const base = state.jigsaw[GET_USER_INFO];
  return !isPending(base) && !base.hasError;
}

export function isJigsawSessionPending(state) {
  return isPending(state.jigsaw[GET_USER_INFO]);
}



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/user-info-selectors.js